import { orderTypes } from 'shared/constants/orderTypes';

export const GET_ENTITY = 'GET_ENTITY';
export const GET_ENTITY_SUCCESS = 'GET_ENTITY_SUCCESS';
export const GET_ENTITY_ERROR = 'GET_ENTITY_ERROR';

export const GET_ENTITY_DOCUMENTS = 'GET_ENTITY_DOCUMENTS';
export const GET_ENTITY_DOCUMENTS_SUCCESS = 'GET_ENTITY_DOCUMENTS_SUCCESS';
export const GET_ENTITY_DOCUMENTS_ERROR = 'GET_ENTITY_DOCUMENTS_ERROR';

export const GET_ENTITY_PRODUCTS = 'GET_ENTITY_PRODUCTS';
export const GET_ENTITY_PRODUCTS_SUCCESS = 'GET_ENTITY_PRODUCTS_SUCCESS';
export const GET_ENTITY_PRODUCTS_ERROR = 'GET_ENTITY_PRODUCTS_ERROR';

export const GET_ENTITY_INSTRUMENTS = 'GET_ENTITY_INSTRUMENTS';
export const GET_ENTITY_INSTRUMENTS_SUCCESS = 'GET_ENTITY_INSTRUMENTS_SUCCESS';
export const GET_ENTITY_INSTRUMENTS_ERROR = 'GET_ENTITY_INSTRUMENTS_ERROR';

export const GET_ENTITY_RATING_NEWS = 'GET_ENTITY_RATING_NEWS';
export const GET_ENTITY_RATING_NEWS_SUCCESS = 'GET_ENTITY_RATING_NEWS_SUCCESS';
export const GET_ENTITY_RATING_NEWS_ERROR = 'GET_ENTITY_RATING_NEWS_ERROR';

export const GET_ENTITY_RESEARCH = 'GET_ENTITY_RESEARCH';
export const GET_ENTITY_RESEARCH_SUCCESS = 'GET_ENTITY_RESEARCH_SUCCESS';
export const GET_ENTITY_RESEARCH_ERROR = 'GET_ENTITY_RESEARCH_ERROR';

export const REQUEST_ENTITY_RATING = 'REQUEST_ENTITY_RATING';
export const REQUEST_ENTITY_RATING_SUCCESS = 'REQUEST_ENTITY_RATING_SUCCESS';
export const REQUEST_ENTITY_RATING_ERROR = 'REQUEST_ENTITY_RATING_ERROR';

export const REQUEST_ENTITY_RATING_AND_FETCH_DATA = 'REQUEST_ENTITY_RATING_AND_FETCH_DATA';
export const REQUEST_ENTITY_RATING_AND_FETCH_DATA_SUCCESS =
  'REQUEST_ENTITY_RATING_AND_FETCH_DATA_SUCCESS';
export const REQUEST_ENTITY_RATING_AND_FETCH_DATA_ERROR =
  'REQUEST_ENTITY_RATING_AND_FETCH_DATA_ERROR';

export const REQUEST_SIG_ENTITY_RATING = 'REQUEST_SIG_ENTITY_RATING';
export const REQUEST_SIG_ENTITY_RATING_SUCCESS = 'REQUEST_SIG_ENTITY_RATING_SUCCESS';
export const REQUEST_SIG_ENTITY_RATING_ERROR = 'REQUEST_SIG_ENTITY_RATING_ERROR';

export const REFRESH_ENTITY = 'REFRESH_ENTITY';
export const REQUEST_CONFIRMATION_CHANGED = 'REQUEST_CONFIRMATION_CHANGED';

export const SET_ENTITY_CREDIT_RATING_VISIBILITY = 'SET_ENTITY_CREDIT_RATING_VISIBILITY';

export const getEntityAction = ({ id }) => ({
  type: GET_ENTITY,
  payload: {
    id,
  },
});

export const getEntityDocumentsAction = ({ entityId }) => ({
  type: GET_ENTITY_DOCUMENTS,
  payload: {
    entityId,
  },
});

export const getEntityProductsAction = ({ entityId }) => ({
  type: GET_ENTITY_PRODUCTS,
  payload: {
    entityId,
  },
});

export const getEntityInstrumentsAction = ({ entityId, page, limit, sort, filter }) => ({
  type: GET_ENTITY_INSTRUMENTS,
  payload: {
    entityId,
    page,
    limit,
    sort,
    filter,
  },
});

export const getEntityRatingNewsAction = ({ entityId, query, page, limit }) => ({
  type: GET_ENTITY_RATING_NEWS,
  payload: {
    entityId,
    query,
    type: 'ENTITY_RATING_NEWS',
    page,
    limit,
  },
});

export const getEntityResearchAction = ({
  entityId,
  query,
  page,
  limit,
  settings,
  industryCode,
}) => ({
  type: GET_ENTITY_RESEARCH,
  payload: {
    entityId,
    query,
    type: 'INDUSTRY_RESEARCH',
    page,
    limit,
    settings,
    industryCode,
  },
});

export const requestEntityRatingAction = ({ id, level }) => ({
  type: REQUEST_ENTITY_RATING,
  payload: {
    id,
    type: orderTypes.ENTITY,
    frequency: 0,
    productCategory: level,
    purchaseType: 'ONE_TIME',
  },
});

export const requestEntityRatingAndFetchDataAction = ({ id, level }) => ({
  type: REQUEST_ENTITY_RATING_AND_FETCH_DATA,
  payload: {
    id,
    type: orderTypes.ENTITY,
    frequency: 0,
    level,
    purchaseType: 'ONE_TIME',
  },
});

export const requestSigEntityRatingAction = ({
  ids,
  organisationId,
  userId,
  selectAll = false,
}) => ({
  type: REQUEST_SIG_ENTITY_RATING,
  payload: {
    ids: !selectAll ? ids : undefined,
    type: orderTypes.SIG_ENTITY,
    organisationId,
    userId,
    selectAll,
  },
});

export const refreshEntityAction = () => ({
  type: REFRESH_ENTITY,
});

export const requestConfirmationChangedAction = ({ confirmed, autoConfirm = false }) => ({
  type: REQUEST_CONFIRMATION_CHANGED,
  payload: {
    confirmed,
    autoConfirm,
  },
});

export const setEntityCreditRatingVisibility = ({ isVisible }) => ({
  type: SET_ENTITY_CREDIT_RATING_VISIBILITY,
  payload: {
    isVisible,
  },
});
